'use strict';

const Backbone = require('backbone');
const Moment = require('moment');

module.exports = Backbone.Model.extend({
    defaults: {
        target: null,
        type: null,
        activatedAt: null,
        deactivatedAt: null,
        detail: null,
        autoRenewal: false
    },

    getTarget: function() {
        return this.get('target');
    },

    getType: function() {
        return this.get('type');
    },

    getActivatedAt: function() {
        return Moment(this.get('activatedAt'));
    },

    getDeactivatedAt: function() {
        return Moment(this.get('deactivatedAt'));
    },

    isAutoRenewal: function() {
        return this.get('autoRenewal');
    }
});



// WEBPACK FOOTER //
// ./common/domain/entity/license.js